<template>
  <v-app class="app">
    <v-app-bar clipped-left app color="primary accent-4" dark>
      <v-app-bar-nav-icon @click="drawer = !drawer"></v-app-bar-nav-icon>
      <v-toolbar-title class="pl-2 text-h5">
        <span>B</span>
        <span class="font-weight-medium">ulk</span>SMS
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <template v-if="user.options">
        <v-btn
          v-if="user.options.BillingType === 'PrePaid'"
          outlined
          color="white"
          @click="refreshBalance()"
        >
          <span
            >{{ $utils.pad(user.options.__cms_credit_smsCredit, 2) }} SMS</span
          >
        </v-btn>
      </template>
      <v-menu left bottom>
        <template v-slot:activator="{ on }">
          <v-btn icon v-on="on">
            <v-icon>mdi-dots-vertical</v-icon>
          </v-btn>
        </template>
        <v-list class="menu-app-bar">
          <v-list-item :to="{ name: 'logout' }">
            <v-list-item-title>{{
              $vuetify.lang.t('$vuetify.menu.logout')
            }}</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-app-bar>
    <v-navigation-drawer
      class="navigation"
      width="240"
      app
      clipped
      v-model="drawer"
    >
      <div v-bar :style="{ height: windowHeight + 'px' }">
        <div>
          <v-list>
            <v-list-item>
              <v-list-item-avatar size="50">
                <v-img src="/img/user.png"></v-img>
              </v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-title>
                  <span class="font-weight-bold grey--text text--darken-3">{{
                    user.name
                  }}</span>
                </v-list-item-title>
                <v-list-item-subtitle>{{
                  user.role
                    ? $vuetify.lang.t('$vuetify.roles.' + user.role)
                    : ''
                }}</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-list>
          <v-divider></v-divider>
          <v-list dense nav>
            <v-list-item
              exact
              exact-active-class="grey lighten-4 primary--text"
              class="mt-1 mb-2"
              link
              :to="{ name: 'dashboard' }"
            >
              <v-list-item-icon>
                <v-icon>mdi-view-dashboard-outline</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title class="font-weight-bold">{{
                  $vuetify.lang.t('$vuetify.menu.dashboard')
                }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-group
              prepend-icon="mdi-message-text-outline"
              no-action
              :value="
                isRoute([
                  'pushes-simple',
                  'pushes-simple-details',
                  'pushes-simple-create',
                  'pushes-advanced',
                  'pushes-advanced-details',
                  'pushes-advanced-create',
                ])
              "
              :class="{
                'grey lighten-4 primary--text': isRoute([
                  'pushes-simple',
                  'pushes-simple-details',
                  'pushes-simple-create',
                  'pushes-advanced',
                  'pushes-advanced-create',
                ]),
              }"
              :active-class="
                isRoute([
                  'pushes-simple',
                  'pushes-simple-create',
                  'pushes-advanced',
                  'pushes-advanced-details',
                  'pushes-advanced-create',
                ])
                  ? 'grey lighten-4 primary--text'
                  : ''
              "
              shaped
            >
              <template v-slot:activator>
                <v-list-item-content>
                  <v-list-item-title class="font-weight-bold">{{
                    $vuetify.lang.t('$vuetify.menu.pushes.title')
                  }}</v-list-item-title>
                </v-list-item-content>
              </template>
              <v-list-item
                link
                :to="{ name: 'pushes-simple' }"
                :active-class="
                  isRoute([
                    'pushes-simple',
                    'pushes-simple-create',
                    'pushes-simple-details',
                  ])
                    ? 'primary--text'
                    : ''
                "
                :exact-active-class="
                  isRoute([
                    'pushes-simple',
                    'pushes-simple-create',
                    'pushes-simple-details',
                  ])
                    ? 'primary--text'
                    : ''
                "
                class="grey lighten-5 mb-0"
              >
                <v-list-item-title class="font-weight-bold">{{
                  $vuetify.lang.t('$vuetify.menu.pushes.simple')
                }}</v-list-item-title>
              </v-list-item>
              <v-list-item
                link
                :to="{ name: 'pushes-advanced' }"
                :active-class="
                  isRoute([
                    'pushes-advanced',
                    'pushes-advanced-create',
                    'pushes-advanced-details',
                  ])
                    ? 'primary--text'
                    : ''
                "
                :exact-active-class="
                  isRoute([
                    'pushes-advanced',
                    'pushes-advanced-details',
                    'pushes-advanced-create',
                  ])
                    ? 'primary--text'
                    : ''
                "
                class="grey lighten-5 mt-0"
              >
                <v-list-item-title class="font-weight-bold">{{
                  $vuetify.lang.t('$vuetify.menu.pushes.advanced')
                }}</v-list-item-title>
              </v-list-item>
            </v-list-group>
            <v-list-group
              prepend-icon="mdi-email-outline"
              no-action
              :value="isRoute(['sms-sent', 'sms-queue'])"
              :class="{
                'grey lighten-4 primary--text': isRoute([
                  'sms-sent',
                  'sms-queue',
                ]),
              }"
              :active-class="
                isRoute(['sms-sent', 'sms-queue'])
                  ? 'grey lighten-4 primary--text'
                  : ''
              "
              shaped
            >
              <template v-slot:activator>
                <v-list-item-content>
                  <v-list-item-title class="font-weight-bold">{{
                    $vuetify.lang.t('$vuetify.menu.sms.title')
                  }}</v-list-item-title>
                </v-list-item-content>
              </template>
              <v-list-item
                link
                :to="{ name: 'sms-sent' }"
                :active-class="isRoute(['sms-sent']) ? 'primary--text' : ''"
                :exact-active-class="
                  isRoute(['sms-sent']) ? 'primary--text' : ''
                "
                class="grey lighten-5 mb-0"
              >
                <v-list-item-title class="font-weight-bold">{{
                  $vuetify.lang.t('$vuetify.menu.sms.sent')
                }}</v-list-item-title>
              </v-list-item>
              <v-list-item
                link
                :to="{ name: 'sms-queue' }"
                :active-class="isRoute(['sms-queue']) ? 'primary--text' : ''"
                :exact-active-class="
                  isRoute(['sms-queue']) ? 'primary--text' : ''
                "
                class="grey lighten-5 mt-0"
              >
                <v-list-item-title class="font-weight-bold">{{
                  $vuetify.lang.t('$vuetify.menu.sms.queue')
                }}</v-list-item-title>
              </v-list-item>
            </v-list-group>
            <v-list-item
              class="mt-2"
              :active-class="
                ['provisions'].includes($route.name)
                  ? 'grey lighten-4 primary--text'
                  : ''
              "
              link
              exact
              :to="{ name: 'provisions' }"
            >
              <v-list-item-icon>
                <v-icon>mdi-wallet-outline</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title class="font-weight-bold">{{
                  $vuetify.lang.t('$vuetify.menu.provisions')
                }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item
              class="mt-2"
              :active-class="
                ['archives'].includes($route.name)
                  ? 'grey lighten-4 primary--text'
                  : ''
              "
              link
              exact
              :to="{ name: 'archives' }"
            >
              <v-list-item-icon>
                <v-icon>mdi-archive-outline</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title class="font-weight-bold">{{
                  $vuetify.lang.t('$vuetify.menu.archives')
                }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item
              v-if="$auth.check(['ROLE_ADMIN', 'ROLE_SUPER_ADMIN'])"
              class="mt-2"
              :active-class="
                isRoute(['users', 'users-create', 'users-edit'])
                  ? 'grey lighten-4 primary--text'
                  : ''
              "
              link
              :exact-active-class="
                isRoute(['users', 'users-create', 'users-edit'])
                  ? 'grey lighten-4 primary--text'
                  : ''
              "
              :to="{ name: 'users' }"
            >
              <v-list-item-icon>
                <v-icon>mdi-account-multiple-outline</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title class="font-weight-bold">{{
                  $vuetify.lang.t('$vuetify.menu.users')
                }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-group
              prepend-icon="mdi-cog-outline"
              no-action
              :value="isRoute(['servers', 'directories', 'files'])"
              :class="{
                'grey lighten-4 primary--text': isRoute([
                  'servers',
                  'directories',
                  'files',
                ]),
              }"
              :active-class="
                isRoute(['servers', 'directories', 'files'])
                  ? 'primary--text'
                  : ''
              "
              shaped
              v-if="$auth.check(['ROLE_ADMIN', 'ROLE_SUPER_ADMIN'])"
            >
              <template v-slot:activator>
                <v-list-item-content>
                  <v-list-item-title class="font-weight-bold">{{
                    $vuetify.lang.t('$vuetify.menu.systems.title')
                  }}</v-list-item-title>
                </v-list-item-content>
              </template>
              <v-list-item
                link
                :to="{ name: 'servers' }"
                :active-class="isRoute(['servers']) ? 'primary--text' : ''"
                :exact-active-class="
                  isRoute(['servers']) ? 'primary--text' : ''
                "
                class="grey lighten-5 mb-0"
              >
                <v-list-item-title class="font-weight-bold">{{
                  $vuetify.lang.t('$vuetify.menu.systems.servers')
                }}</v-list-item-title>
              </v-list-item>
              <v-list-item
                link
                :to="{ name: 'directories' }"
                :active-class="isRoute(['directories']) ? 'primary--text' : ''"
                :exact-active-class="
                  isRoute(['directories']) ? 'primary--text' : ''
                "
                class="grey lighten-5 mb-0"
              >
                <v-list-item-title class="font-weight-bold">{{
                  $vuetify.lang.t('$vuetify.menu.systems.directories')
                }}</v-list-item-title>
              </v-list-item>
              <v-list-item
                link
                :to="{ name: 'files' }"
                :active-class="isRoute(['files']) ? 'primary--text' : ''"
                :exact-active-class="isRoute(['files']) ? 'primary--text' : ''"
                class="grey lighten-5 mb-0"
              >
                <v-list-item-title class="font-weight-bold">{{
                  $vuetify.lang.t('$vuetify.menu.systems.priorities')
                }}</v-list-item-title>
              </v-list-item>
            </v-list-group>
            <v-list-item
              class="mt-2"
              :active-class="
                isRoute(['profile']) ? 'grey lighten-4 primary--text' : ''
              "
              link
              :exact-active-class="
                isRoute(['profile']) ? 'grey lighten-4 primary--text' : ''
              "
              :to="{ name: 'profile' }"
            >
              <v-list-item-icon>
                <v-icon>mdi-account-details-outline</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title class="font-weight-bold">{{
                  $vuetify.lang.t('$vuetify.menu.profile')
                }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-group
              prepend-icon="mdi-code-braces"
              no-action
              :value="isRoute(['developer', 'developer-balance'])"
              :class="{
                'grey lighten-4 primary--text': isRoute([
                  'developer',
                  'developer-balance',
                ]),
              }"
              :active-class="
                isRoute(['developer', 'developer-balance'])
                  ? 'grey lighten-4 primary--text'
                  : ''
              "
              shaped
            >
              <template v-slot:activator>
                <v-list-item-content>
                  <v-list-item-title class="font-weight-bold">{{
                    $vuetify.lang.t('$vuetify.menu.developer.title')
                  }}</v-list-item-title>
                </v-list-item-content>
              </template>
              <v-list-item
                link
                :to="{ name: 'developer' }"
                :active-class="isRoute(['developer']) ? 'primary--text' : ''"
                :exact-active-class="
                  isRoute(['developer']) ? 'primary--text' : ''
                "
                class="grey lighten-5 mb-0"
                :exact="true"
              >
                <v-list-item-title class="font-weight-bold">{{
                  $vuetify.lang.t('$vuetify.menu.developer.sent')
                }}</v-list-item-title>
              </v-list-item>
              <v-list-item
                link
                :to="{ name: 'developer-balance' }"
                :active-class="
                  isRoute(['developer-balance']) ? 'primary--text' : ''
                "
                :exact-active-class="
                  isRoute(['developer-balance']) ? 'primary--text' : ''
                "
                class="grey lighten-5 mb-0"
              >
                <v-list-item-title class="font-weight-bold">{{
                  $vuetify.lang.t('$vuetify.menu.developer.balance')
                }}</v-list-item-title>
              </v-list-item>
            </v-list-group>
          </v-list>
        </div>
      </div>
    </v-navigation-drawer>
    <v-main v-if="!loading">
      <router-view></router-view>
    </v-main>
    <v-main v-else>
      <div class="text-center mt-5">
        <v-progress-circular
          indeterminate
          color="secondary"
          width="3"
          size="80"
        ></v-progress-circular>
      </div>
    </v-main>
    <v-footer>
      <v-spacer></v-spacer>
      <div class="font-weight-bold grey--text text--darken-1 text-body-2">
        &copy; LMTGROUP BulkSMS {{ $moment().format('YYYY') }}
      </div>
    </v-footer>
  </v-app>
</template>

<style lang="scss">
.app {
  background: #f0ebf8 !important;
}
.navigation {
  .v-list-item--link {
    &:before {
      background: none !important;
    }
  }
  .v-list-item__title {
    font-size: 0.96rem !important;
  }
}
</style>

<script>
export default {
  data: () => ({
    drawer: true,
    loading: true,
    windowHeight: null,
    windowWidth: null,
  }),
  async beforeRouteEnter(to, from, next) {
    next(async (vm) => {
      vm.loading = true;
      try {
        await vm.$store.dispatch('setTime');
      } catch (error) {
        // empty
      }
      vm.loading = false;
    });
  },
  mounted: function() {
    let self = this;
    this.windowWidth = window.innerWidth;
    this.windowHeight = window.innerHeight - 70;

    this.$nextTick(function() {
      window.addEventListener('resize', function() {
        self.windowHeight = window.innerHeight - 70;
      });
      window.addEventListener('resize', function() {
        self.windowWidth = window.innerWidth;
      });
    });
  },
  methods: {
    isRoute(routes) {
      return routes.includes(this.$route.name);
    },
    refreshBalance() {
      this.$auth.fetch();
    },
  },
  computed: {
    user() {
      return this.$auth.user() || { options: {} };
    },
  },
};
</script>
